import React from 'react';
import { style } from 'typestyle';
import CheckIcon from 'mdi-react/CheckCircleIcon';
import * as styles from '../cards.styles';
import Column from '../../../../core/components/column/column.component';
import { MainAxisAlignment, CrossAxisAlignment } from '../../../../core/components/flex/flex.component';
import Row from '../../../../core/components/row/row.component';
import type Department from '../../../offices/models/department/department';

interface Props {
  readonly department: Department;
  readonly isSelected: boolean;
  readonly onClick: (department: Department) => void;
}

const DayPartDepartmentCard = ({ department, isSelected, onClick }: Props): React.JSX.Element => (
  <div
    className={style(styles.infoCard(true))}
    key={department.name}
    onClick={(): void => {
      onClick(department);
    }}
    role="presentation"
  >
    <Row mainAxisAlignment={MainAxisAlignment.SpaceBetween} crossAxisAlignment={CrossAxisAlignment.Center}>
      <Column mainAxisAlignment={MainAxisAlignment.SpaceBetween}>
        <span className={style(styles.cardHeader())}>{department.name}</span>
      </Column>
      <CheckIcon className={style(styles.checkIcon(isSelected))} />
    </Row>
  </div>
);

export default DayPartDepartmentCard;
